export const CREATING_POSTAL_NUMBER = 'CREATING_POSTAL_NUMBER';
export const FETCHING_PRICES = 'FETCHING_PRICES';
export const UPDATING_PRICES = 'UPDATING_PRICES';